/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRP, setCurrentPage } from "../../Redux/reducers/recentProduct";
import ItemCard from "../Common/Item/ItemCard";
import LoadMore from "../Common/LoadMore";
import NoItems from "../Common/NoItems";
import SectionHead from "../Common/SectionHead";
import ShimmerCard from "../Common/Shimmer/ShimmerCard";

const RecentProducts = ({ firstLabel, secondLabel }) => {

  const dispatch = useDispatch();
  const selectedCity = useSelector((state) => state.selectedCity.selectedCity);

  const isRecentLoading = useSelector(
    (state) => state.recentProducts.isRecentLoading
  );
  const isRecentError = useSelector(
    (state) => state.recentProducts.isRecentError
  );
  const isFirst = useSelector((state) => state.recentProducts.isFirst);
  const recentProducts = useSelector(
    (state) => state.recentProducts.recentProducts
  );
  const forPagination = useSelector(
    (state) => state.recentProducts.forPagination
  );
  const currentPage = useSelector((state) => state.recentProducts.currentPage);
  // const [itemCarouselModal, setItemCarouselModal] = useState(false);
  const [y, setY] = useState(window.scrollY);

  // const { width } = useWindowDimensions();

  const handleNavigation = useCallback(
    (e) => {
      onScrollToBottom();
      setY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    // setY(window.scrollY);
    // window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  const onScrollToBottom = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 150
    ) {
      if (forPagination.next_page_url) {
        dispatch(
          fetchRP({
            page: currentPage + 1,
            stateChange: false,
            selectedCity: selectedCity,
          })
        );
        dispatch(setCurrentPage(currentPage + 1));
      }
    }
  };

  return (
    <div>
      <SectionHead
        onViewPress={() => {
          // setItemCarouselModal(true);
        }}
        leadFirstLabel={firstLabel}
        leadSecondLabel={secondLabel}
        trailingFirstLabel=""
        trailingSecondLabel=""
      />
      <div className="d-flex flex-wrap mb-5">
        {isRecentLoading && isFirst ? (
          <>
            {Array(7)
              .fill()
              .map((_, index) => {
                return (
                  <ShimmerCard
                    key={index}
                    clsName="col-6 col-md-4 col-lg-3"
                    index={index}
                  />
                );
              })}
          </>
        ) : isRecentError ? (
          <>
            <div className="search-message">
              Error retriving recent products!
            </div>
          </>
        ) : recentProducts.length <= 0 ? (
          <>
            <NoItems />
          </>
        ) : (
          <>
            {recentProducts.map((item, index) => {
              return (
                <ItemCard
                  key={index}
                  item={item}
                  clsName="col-6 col-md-4 col-lg-3 cursor-pointer"
                  index={index}
                />
              );
            })}
            {isRecentLoading &&
              Array(10)
                .fill()
                .map((_, index) => {
                  return (
                    <ShimmerCard
                      key={index}
                      clsName="col-6 col-md-4 col-lg-3"
                      index={index}
                    />
                  );
                })}
            <LoadMore
              forPagination={forPagination}
              onClick={() => {
                dispatch(
                  fetchRP({
                    page: currentPage + 1,
                    stateChange: false,
                    selectedCity: selectedCity,
                  })
                );
                dispatch(setCurrentPage(currentPage + 1));
              }}
            />

          </>
        )}
      </div>
    </div>
  );
};

export default RecentProducts;
